import { useContext, useMemo, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import LanguageContext from '../Context/LanguageContext';
import { useStorePathPrefix } from '../lib/storefront/storePath';

export function useAppLanguage() {
    const { t, i18n } = useTranslation();
    const { currentLanguage, changeLanguage, dir } = useContext(LanguageContext);
    const storePrefix = useStorePathPrefix();

    const langPrefix = useMemo(() => `/${currentLanguage}`, [currentLanguage]);

    const langPath = useCallback((path = '/') => {
        const clean = path.startsWith('/') ? path : `/${path}`;
        const withLang = clean === '/' ? langPrefix : `${langPrefix}${clean}`;
        return `${storePrefix}${withLang}`;
    }, [langPrefix, storePrefix]);

    return {
        t,
        i18n,
        selectedLanguage: currentLanguage,
        currentLanguage,
        changeLanguage,
        dir: dir(),
        isRtl: dir() === 'rtl',
        langPrefix,
        langPath,
    };
}
